import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
//import { ConnectedRouter } from 'react-router-redux';
import { configureStore } from 'store';
import App from './App';
import { unregister } from './registerServiceWorker';
// import AmplifyHubListener from './lib/AmplifyHubListener';
import { Auth } from 'lib/Auth';
import history from 'lib/History';
import { Route, Router } from 'react-router';

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;

const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

Auth.setStore(store, history);

// AmplifyHubListener(store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Route component={App} />
    </Router>
  </Provider>,
  rootElement
);

unregister();
